<rl-please-wait *ngIf="!allSubs?.length" [disable]="true"></rl-please-wait>
<div *ngIf="allSubs?.length" class="middle-content full-view-page hide-right-panel embedded-full-view asgmt-page"> 
	<div class="item-view" *ngIf="asgmt">
		<div class="section-block main-block MarginItem">
			<div class="media">
				<div class="media-body no-padding">
					<div class="media-heading">
						<div class="citation-title justify-content">
							<div class="flex-start">
								<h1 class="media-title">{{asgmt.title}}</h1>
							</div>
						</div>
					</div>
					<p class="padding-right"><span class="ContentSummary">{{'asgmt.view.instructions' | translate}}:</span> {{asgmt.description}}</p>
				</div>
			</div>
		</div>
		<div *ngIf="allSubs?.length" class="justify-content">
			<div class="flex-start">
				<div class="justify-content">
					<div [hidden]="!currIndex" class="flex-basis">
						<button class="btn btn-clear" id="prev-student" (click)="prev()" type="button" [disabled]="currIndex == 0" (mouseup)="userName.classList.remove('slideRight');userName.classList.add('slideLeft');" [rlAria]="'grading.students.prev' | translate" [rlTabIndex]>
		                    <i class="fa fa-chevron-left"></i>
		                    <span class="sr-only">{{'grading.students.prev' | translate}}</span>
		                </button>
					</div>
					<div class="flex-basis">
						<div class="user-full-name-holder">
							<div #userName class="user-full-name">
								<span class="instructor-name"><span [ngStyle]="{'color': (allSubs[currIndex].submission.creator | hsl)}">
									{{allSubs[currIndex].user.family_name}} {{allSubs[currIndex].user.given_name}}</span></span>
							</div>
							<div class="user-activity" *ngIf="hasUnSaveChanges()">*</div>
						</div>
					</div>
					<div [hidden]="currIndex == allSubs?.length - 1" class="flex-basis">
						<button class="btn btn-clear" id="next-student" (click)="next()" type="button" [disabled]="(currIndex + 1) == (allSubs.length)" (mouseup)="userName.classList.remove('slideLeft');userName.classList.add('slideRight');" [rlAria]="'grading.students.next' | translate" [rlTabIndex]>
		                    <i class="fa fa-chevron-right"></i>
		                    <span class="sr-only">{{'grading.students.next' | translate}}</span>
		                </button>
					</div>
					<div *ngIf="allSubs?.length > 1" class="flex-basis double-margin-left">
						<div class="to-be-graded">
							<span class="semi-bold">{{currIndex + 1}}</span>/{{allSubs?.length}} {{'asgmt.statistics.needToGrade' | translate}}
						</div>
					</div>
				</div>
			</div>
			<div class="flex-end" *ngIf="asgmt">
				<div class="justify-content">
					<div class="flex-basis double-margin-right">
						<span><span class="ContentSummary">{{'asgmt.statistics.avg' | translate}}</span> {{asgmt.statistics.avg | number:'1.0-2' | forDisplay}}</span>
					</div>
					<div class="flex-basis double-margin-right">
						<span><span class="ContentSummary">{{'asgmt.statistics.high' | translate}}</span> {{asgmt.statistics.high | forDisplay}}</span>
					</div>
					<div class="flex-basis double-margin-right">
						<span><span class="ContentSummary">{{'asgmt.statistics.low' | translate}}</span> {{asgmt.statistics.low | forDisplay}}</span>
					</div>
				</div>
				<div class="due-dates-box">
					<p>{{'asgmt.view.submission.submittedOn' | translate}}: 
						<span class="citation-due-date semi-bold">
							{{allSubs[currIndex].submission.userSubmissionDate | customerDateTime}}
						</span>
					</p>
				</div>
			</div>
		</div>
		<rl-submission-view [assignment]="asgmt" [studentSubmission]="allSubs[currIndex]" (onSave)="onSaveSubmission($event)" (onNext)="this.currIndex = this.currIndex + 1" [showNext]="this.currIndex < this.allSubs?.length - 1"></rl-submission-view>
	</div>
</div>